export default __webpack_public_path__ + "static/media/clothes.6f788411.png";